import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const CommercialHighlight = () => {
  const commercialPartners = [
  {
    name: "McDonald\'s",
    logo: "https://images.unsplash.com/photo-1546443239-40689cb3b774",
    logoAlt: "McDonald\'s golden arches logo on red background with iconic fast food branding",
    projectCount: '15+',
    description: 'Complete plumbing and electrical installations across multiple locations'
  },
  {
    name: 'KFC',
    logo: "https://images.unsplash.com/photo-1697616660956-6c0afd855125",
    logoAlt: "KFC Colonel Sanders logo with red and white branding on restaurant signage",
    projectCount: '12+',
    description: 'Emergency response and maintenance contracts for restaurant facilities'
  }];


  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-lg border border-primary/20 p-6 md:p-8 mb-8 md:mb-12">
      <div className="text-center mb-6 md:mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-primary/10 mb-4">
          <Icon name="Award" size={32} className="text-primary md:w-10 md:h-10" />
        </div>
        <h2 className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-3 md:mb-4">
          Trusted by Major Brands
        </h2>
        <p className="text-muted-foreground text-base md:text-lg font-body max-w-2xl mx-auto">
          Our expertise has been proven through long-term partnerships with industry-leading commercial clients
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {commercialPartners?.map((partner, index) =>
        <div
          key={index}
          className="bg-card rounded-lg border border-border p-6 md:p-8 hover:shadow-elevated transition-shadow duration-300">

            <div className="flex items-center gap-4 mb-4">
              <Image
              src={partner?.logo}
              alt={partner?.logoAlt}
              className="w-20 h-20 md:w-24 md:h-24 rounded-lg object-cover" />

              <div>
                <h3 className="font-headline font-bold text-xl md:text-2xl text-foreground mb-1">
                  {partner?.name}
                </h3>
                <p className="text-accent font-accent font-semibold text-lg md:text-xl">
                  {partner?.projectCount} Projects
                </p>
              </div>
            </div>
            <p className="text-muted-foreground text-sm md:text-base font-body">
              {partner?.description}
            </p>
          </div>
        )}
      </div>
      <div className="mt-6 md:mt-8 text-center">
        <div className="inline-flex items-center gap-2 text-success font-medium text-sm md:text-base">
          <Icon name="CheckCircle2" size={20} />
          <span className="font-body">Long-term maintenance contracts &amp; emergency response partnerships</span>
        </div>
      </div>
    </div>);

};

export default CommercialHighlight;